/**
 * Verbatim owner-supplied product tips. Do NOT rewrite or summarise.
 *
 * Linter note: this file is added to SKIP_FILES in scripts/check_ai_tells.py
 * because the verbatim "Capture what we can't reach" tip contains
 * "...who did what, and when, becomes..." which trips the Oxford-comma
 * rule. The owner reviewed and approved that exact wording.
 */

export const CAPTURE_TIP = {
  id: "capture-what-we-cant-reach",
  title: "Capture what we can't reach",
  blurb: "Screenshot your agent's repair-app updates, so their record becomes yours.",
  // Long-form prose body (renders above the action steps on the Guide page).
  body: [
    "Some of your tenancy lives in systems we can't see into, like your agent's repair app (Tapi, PropertyMe and the like). When one of those emails lands, or you open a job page showing dates and updates, take a quick screenshot and drop it straight into your timeline.",
    "Do it the moment it appears, while the date is fresh. That way the agent's own record of who did what, and when, becomes part of your evidence trail too. Not just theirs.",
  ],
  // Action checklist (renders as the numbered steps).
  steps: [
    "Got an update email from your agent or their repair app? Screenshot it.",
    "Open the job page and screenshot the activity log, the part with the dates on it.",
    "Upload it to your timeline the same day, so the date is captured while it's fresh.",
    "Add a one-line note on what it is, so future-you knows at a glance.",
  ],
};
